import { FC, memo } from 'react'

import { TextBadgeProps } from '../props'

import * as SC from './styles'

export const TextBadge: FC<TextBadgeProps> = memo((props) => {
  const { isNumber = false, color, children, ...rest } = props

  switch (color) {
    case 'default':
      return (
        <SC.TextBadgeDefault $isNumber={isNumber} {...rest}>
          {children}
        </SC.TextBadgeDefault>
      )
    case 'black':
      return (
        <SC.TextBadgeBlack $isNumber={isNumber} {...rest}>
          {children}
        </SC.TextBadgeBlack>
      )
    case 'white':
      return (
        <SC.TextBadgeWhite $isNumber={isNumber} {...rest}>
          {children}
        </SC.TextBadgeWhite>
      )
    case 'positive':
      return (
        <SC.TextBadgePositive $isNumber={isNumber} {...rest}>
          {children}
        </SC.TextBadgePositive>
      )
    case 'disabled':
      return (
        <SC.TextBadgeDisabled $isNumber={isNumber} {...rest}>
          {children}
        </SC.TextBadgeDisabled>
      )
    case 'warning':
      return (
        <SC.TextBadgeWarning $isNumber={isNumber} {...rest}>
          {children}
        </SC.TextBadgeWarning>
      )
    case 'warning_secondary':
      return (
        <SC.TextBadgeWarningSecondary $isNumber={isNumber} {...rest}>
          {children}
        </SC.TextBadgeWarningSecondary>
      )
    case 'error':
      return (
        <SC.TextBadgeError $isNumber={isNumber} {...rest}>
          {children}
        </SC.TextBadgeError>
      )
    case 'none':
      return null
    default:
      return null
  }
})
